import React, { createContext, useContext, useState } from 'react';

export const DEFAULT_FLAVORS = [
  "Lime Squash",
  "Orange Crush",
  "Pineapple Punch"
];

export const FLAVOR_COLORS = {
  "Lime Squash": "green",
  "Orange Crush": "orange",
  "Pineapple Punch": "amber"
};

type FlavorContextType = {
  availableFlavors: string[];
  addFlavor: (flavor: string) => void;
};

const FlavorContext = createContext<FlavorContextType>({
  availableFlavors: DEFAULT_FLAVORS,
  addFlavor: () => {}
});

export const useFlavorContext = () => useContext(FlavorContext);

export const FlavorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [availableFlavors, setAvailableFlavors] = useState<string[]>(DEFAULT_FLAVORS);

  const addFlavor = (flavor: string) => {
    if (!flavor || flavor.trim() === '') return;

    setAvailableFlavors(prev => {
      if (prev.includes(flavor)) return prev;
      return [...prev, flavor];
    });
  };

  return (
    <FlavorContext.Provider value={{ availableFlavors, addFlavor }}>
      {children}
    </FlavorContext.Provider>
  );
};
